import Vue from "vue"
import Vuex from "vuex"

import { vuexfireMutations } from "vuexfire"
import modules from "./modules"

Vue.use(Vuex)

// mutations
const mutations = { ...vuexfireMutations }

// actions
const actions = {
  /**
   * Reset all module's state.
   *
   * @param {object} context - Vuex context.
   */
  reset({ commit }) {
    Object.keys(modules).forEach((moduleName) => {
      commit(`${moduleName}/reset`)
    })
  }
}

// export module
export default new Vuex.Store({
  modules,
  mutations,
  actions
})
